import { withReadOnly } from '@/hocs/withReadOnly';

import TextField from './TextField';

const ReleaseEnvTextField = withReadOnly(TextField);

export { ReleaseEnvTextField };
export default TextField;
